import * as Yup from "yup";

const etiquetasValidator = Yup.object().shape({
  ativado: Yup.boolean().nullable(),
  descricao: Yup.string().required("Descrição"),
  larguraFolha: Yup.number().min(1).required("Largura da Folha"),
  alturaEtiqueta: Yup.number().min(1).required("Altura da Etiqueta"),
  margemBordaEtiqueta: Yup.number().required("Margem Lateral da Etiqueta"),
  margemMeioEtiqueta: Yup.number().required("Margem Lateral da Etiqueta"),
  colunasEtiqueta: Yup.number().required("Colunas da Etiqueta"),
  layout: Yup.array()
    .of(
      Yup.object().shape({
        elemento: Yup.mixed()
          .oneOf(["DESCRICAO", "COD", "PRECO", "CODBAR"])
          .required("Tipo do Elemento"),
        x: Yup.number().required("Posição x"),
        y: Yup.number().required("Posição y"),
        fontSize: Yup.number().required("Tamanho da Fonte"),
        codeType: Yup.mixed().oneOf(["1", "3", "E30", "E80", null]),
        codeHeight: Yup.number().nullable(),
        codeWidth: Yup.number().nullable(),
        showLabelCode: Yup.boolean().nullable(),
      })
    )
    .min(1, "Adicionar ao menos um elemento")
    .required(),
});

export default etiquetasValidator;
